import * as React from "react";
const SvgEMobiledataOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M16 9V7H8v10h8v-2h-6v-2h6v-2h-6V9h6z" />
  </svg>
);
export default SvgEMobiledataOutlined;
